import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="md:flex md:w-60 sm:w-40 w-20 hidden max-h-full border-r border-opacity-50 border-yellow-100 font-Fira">
      <ul className="w-60 m-auto">
        <NavLink
          to="/"
          className="w-full block py-5 text-center text-xl border-t border-b border-l  border-yellow-200 border-opacity-0 hover:border-opacity-50  transition-all duration-150"
          activeClassName="text-black bg-yellow-300"
          exact
        >
          Home
        </NavLink>
        <NavLink
          to="/skills"
          className="w-full block py-5 text-center text-xl border-t border-b border-l  border-yellow-200 border-opacity-0 hover:border-opacity-50 transition-all duration-150"
          activeClassName="text-black bg-yellow-300"
        >
          Skills
        </NavLink>
        <NavLink
          to="/projects"
          className="w-full block py-5 text-center text-xl border-t border-b border-l  border-yellow-200 border-opacity-0 hover:border-opacity-50 transition-all duration-150"
          activeClassName="text-black bg-yellow-300"
        >
          Projects
        </NavLink>
        <NavLink
          to="/contact"
          className="w-full block py-5 text-center text-xl border-t border-b border-l  border-yellow-200 border-opacity-0 hover:border-opacity-50 transition-all duration-150"
          activeClassName="text-black bg-yellow-300"
        >
          Contact
        </NavLink>
      </ul>
    </nav>
  );
};

export default Navbar;
